export var PVA = 'Paid via Atlassian';
export var PVV = 'Paid via Vendor';
export var FREE = 'Free';